export enum LocalStorageKey {
  PRODUCT_LISTING_COLUMNS = 'PRODUCT_LISTING_COLUMNS',
  ITEM_DETAIL_FIELDS = 'ITEM_DETAIL_FIELDS',
}
